import React, {useState, useEffect, useMemo} from 'react';
import './css/App.css'
import SectionByDate from './Section-by-date';
import TextArea from './TextArea';
import {dateToday, Local} from './ExtraMethods';

function App() {
  let obj = useMemo(()=>{return {name: 'ralf'}}, [])
  useEffect(()=>{console.log('name changed')}, [obj]);
  let [notes, setNotes] = useState([]);   //notes data is stored here
  
  useEffect(() => {
    //get data from local storage
    setNotes(Local.getLocalData());
  }, []);

  useEffect(() => {
    //store to local storage
    if(notes.length === 0) Local.removeData();
    else Local.storeLocalData(notes);
  }, [notes])

  //adds new note to the data
  const notesUpdate = (color, content, error) => {
    let newObj;
    if(!notes[0] || notes[0].date !== dateToday()) {
      newObj = {
        date: dateToday()
      }
      //insert content to color property
      newObj[color] = content;
      
      //update notes
      let newNotes = [newObj];
      setNotes(newNotes);
      error(false);
    }
    else if(notes[0].date === dateToday()) {
      //already exist
      newObj = notes[0];
      if(!notes[0][color]) {
        newObj[color] = content;
        error(false);
      }
      else {
        error('You can only use one color per day. Edit a note instead');
      }

      setNotes([...notes], notes[0] = newObj);
    }
  }

  const editContent = (index, color, toDelete) => event => {
    if(toDelete) {
      //edit content with delete method
      let newNotes = [...notes];
      delete newNotes[index][color];
      setNotes(newNotes);

      if(notes.length === 1) Local.removeData();

      //checks object still has content
      if(!notes[index]['red'] && !notes[index]['green'] && !notes[index]['blue']) {
        let newNotes = [...notes];
        newNotes.splice(index,1);
        setNotes(newNotes);
      }
    }
    else {
      //edit content no delete
      setNotes([...notes], notes[index][color] = event.target.value)
    }
  }

  return (
    <div className="App">
      <section id="title">
          <div>Diurnal<span>.</span></div>
          <TextArea notesUpdate={notesUpdate}/>
      </section>
      <section>
        { notes.map((item, index) =>
            <SectionByDate 
            item={item} 
            editContent={editContent}
            key={index}
            index={index}
            />
          )
        }
      </section>
    </div>
  );
}

export default App;

